<template>
	<div class="article-view" :style="{ minHeight: !getMobile && getViewport ? `${getViewport.height - 230 - 182}px` : '0' }">
		<div class="article-view__line" v-for="line in articleLines" v-if="line.length > 0">				
			<capsule-article v-for="(item, index) in line" :content-data="item" :propId="index" key="capsule"></capsule-article>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'article-view',
		props: [
			'contentData'
		],
		data () {
			const struct = [3, 3, 2]
			let actualStruct = 0

			const result = []
			let lineCount = 0

			for (let y = 0; y < this.contentData.body.length; y++) {
				if (!result[lineCount]) {
					result[lineCount] = []
				}

				result[lineCount].push(this.contentData.body[y])

				if (result[lineCount].length === struct[actualStruct]) {
					lineCount++
					actualStruct++

					if (actualStruct > 2) {
						actualStruct = 0
					}
				}
			}

			return {
				articleLines: result,
				minHeight: this.$store.getters.getViewport.height
			}
		},
		watch: {
			getViewport (val) {
				this.minHeight = val.height
			}
		},
		computed: {
			getMobile () {
				return this.$store.getters.getMobile
			},
			getViewport () {
				return this.$store.getters.getViewport
			}
		}
	}
</script>

<style lang="scss">
	.article-view__line {
		display: flex;
		align-items: center;
		justify-content: space-between;
		flex-wrap: wrap;
		margin-bottom: 100px;

		@include mobile {
			margin-top: 10px;
			margin-bottom: 0;
		}

		&:nth-child(3n+1) {
			max-width: 90%;

			article {
				@include custom-break-min($mobile) {
					&:first-child {
						margin-top: 30px;
					}

					&:nth-child(2) {
						margin-top: 130px;
					}
				}
			}

			@include tablet {
				max-width: 100%;
			}
		}

		&:nth-child(3n+2) {
			margin: 0 auto 100px;
			max-width: 80%;

			@include mobile { margin-bottom: 0; }

			article {
				@include custom-break-min($mobile) {
					&:first-child {
						margin-top: 100px;
					}

					&:nth-child(2) {
						margin-bottom: 100px;
					}
				}
			}

			@include tablet {
				max-width: 100%;
			}
		}

		&:nth-child(3n+3) {
			margin: 0 auto 100px;
			max-width: 50%;

			@include mobile { margin-bottom: 0; }

			article {
				@include custom-break-min($mobile) {
					&:nth-child(2) {
						margin-top: 50px;
					}
				}
			}

			@include tablet {
				max-width: 100%;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/vue/components/common/article/ArticleView.vue?7b7da87a